import { Drawer, Typography } from "@mui/material";
import { styled } from "styled-components";

export const StyledDrawer = styled(Drawer)(() => ({
  "& .MuiDrawer-paperAnchorBottom": {
    borderRadius: "10px 10px 0 0",
    background: "rgba(17, 17, 17, 0.60)",
    backdropFilter: "blur(20px)",
    "@media (orientation: landscape)": {
      maxWidth: "90%",
      left: "5%",
    },
  },
}));

export const DrawerRoot = styled("div")`
  display: flex;
  flex-direction: column;
  font-family: "Source Sans Pro";
`;

export const DrawerHeader = styled("div")`
  display: flex;
  height: 48px;
  padding: 0 16px;
  align-items: center;
  gap: 8px;
  position: relative;
  background: rgba(255, 255, 255, 0.05);
`;

export const DrawerContent = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 28px 16px;
  align-items: center;
  gap: 28px;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  @media (orientation: landscape) {
    display: grid;
    row-gap: 0;
    grid-template-columns: 3fr 1fr;
    grid-template-rows: auto;
    padding: 64px 16px 64px 48px;
    :nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }

    :nth-child(3) {
      grid-column: 1;
      grid-row: 2;
    }
    :nth-child(2) {
      grid-column: 2;
      grid-row: 1 / span 2;
    }
  }
`;

export const StyledH4 = styled(Typography)`
  color: #fff;
  text-align: center;
  font-family: "Source Sans Pro";
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  //max-width: 270px;
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  @media (orientation: landscape) {
    text-align: left;
  }
`;

export const StyledH6 = styled(Typography)`
  color: #fff;
  text-align: center;
  font-family: "Source Sans Pro";
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  //max-width: 200px;
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  @media (orientation: landscape) {
    text-align: left;
    padding-bottom: 36px;
  }
`;

export const StyledText = styled("span")`
  margin: 0;
`;
